module.exports = __webpack_public_path__ + "static/media/conapred.d0c809d6.jpg";